import React from 'react';

export const CategoriesActiveIcon = ({
  width = '25',
  height = '24',
  stroke = '#5C6370',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.03988 0H6.41988C7.82988 0 8.95988 1.15 8.95988 2.561V5.97C8.95988 7.39 7.82988 8.53 6.41988 8.53H3.03988C1.63988 8.53 0.499878 7.39 0.499878 5.97V2.561C0.499878 1.15 1.63988 0 3.03988 0ZM3.03988 11.4697H6.41988C7.82988 11.4697 8.95988 12.6107 8.95988 14.0307V17.4397C8.95988 18.8497 7.82988 19.9997 6.41988 19.9997H3.03988C1.63988 19.9997 0.499878 18.8497 0.499878 17.4397V14.0307C0.499878 12.6107 1.63988 11.4697 3.03988 11.4697ZM17.96 0H14.58C13.17 0 12.04 1.15 12.04 2.561V5.97C12.04 7.39 13.17 8.53 14.58 8.53H17.96C19.36 8.53 20.5 7.39 20.5 5.97V2.561C20.5 1.15 19.36 0 17.96 0ZM14.58 11.4697H17.96C19.36 11.4697 20.5 12.6107 20.5 14.0307V17.4397C20.5 18.8497 19.36 19.9997 17.96 19.9997H14.58C13.17 19.9997 12.04 18.8497 12.04 17.4397V14.0307C12.04 12.6107 13.17 11.4697 14.58 11.4697Z" fill="#6AA543"/>
    </svg>
  );
};
